import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


const initialState = {
  expenses: [],
  meta_data: [],
  status: [],
  user_expense_stats: [],
  admin_expense_stats: [],
  user_expenses: [],
  user_meta_data: [],
  office_expense_stats: [],
  users_stats: [],
  expenses_stats: [],
  expenses_charts_amount: [],
  expenses_charts_months: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
